import type { HeatmapCellValue } from "./heatmapScale";
import type { HeatmapCell } from "./types";

export const getHeatmapRectangleCells = (anchor: HeatmapCell, target: HeatmapCell): HeatmapCell[] => {
  const minColumn = Math.min(anchor.columnIndex, target.columnIndex);
  const maxColumn = Math.max(anchor.columnIndex, target.columnIndex);
  const minRow = Math.min(anchor.rowIndex, target.rowIndex);
  const maxRow = Math.max(anchor.rowIndex, target.rowIndex);
  const cells: HeatmapCell[] = [];

  for (let columnIndex = minColumn; columnIndex <= maxColumn; columnIndex += 1) {
    for (let rowIndex = minRow; rowIndex <= maxRow; rowIndex += 1) {
      cells.push({ columnIndex, rowIndex });
    }
  }

  return cells;
};

export const isHeatmapCellInRectangle = (cell: HeatmapCell, anchor: HeatmapCell, target: HeatmapCell): boolean => {
  const minColumn = Math.min(anchor.columnIndex, target.columnIndex);
  const maxColumn = Math.max(anchor.columnIndex, target.columnIndex);
  const minRow = Math.min(anchor.rowIndex, target.rowIndex);
  const maxRow = Math.max(anchor.rowIndex, target.rowIndex);

  return (
    cell.columnIndex >= minColumn && cell.columnIndex <= maxColumn && cell.rowIndex >= minRow && cell.rowIndex <= maxRow
  );
};

export const applyValueToHeatmapCells = (
  values: HeatmapCellValue[][],
  cells: HeatmapCell[],
  value: number
): HeatmapCellValue[][] => {
  const next = structuredClone(values);

  cells.forEach((cell) => {
    const row = next[cell.rowIndex];
    if (!row || row[cell.columnIndex] === undefined) return;
    row[cell.columnIndex] = value;
  });

  return next;
};
